<script setup>
import {defineProps, ref} from 'vue'
import ContactUs from "@/components/NewPC/ContactUs.vue";
import {useRouter} from "vue-router";
const router = useRouter();
const props = defineProps({
  active: {
    type: Number,
    default: 0
  }
})

const ContactUsRef = ref(null);


const handleJump = index => {
  if (index == props.active) return;
  switch (index) {
    case 0:
      router.push('/')
      break;
    case 1:
      router.push('/news')
      break;
    case 2:
      router.push('/player-center')
      break;
    case 3:
      router.push('/information')
      break;
    case 4:
      ContactUsRef.value?.open();
      break;
    case 5:
      router.push('/top-up')
      break;
    default:
      break;
  }
}
</script>

<template>
<div class="custom_menu">
  <div :class="{'active': props.active == 0}" @click="handleJump(0)">官网首页</div>
  <div :class="{'active': props.active == 1}" @click="handleJump(1)">新闻</div>
  <div :class="{'active': props.active == 2}" @click="handleJump(2)">玩家中心</div>
  <div :class="{'active': props.active == 3}" @click="handleJump(3)">游戏资料</div>
  <div :class="{'active': props.active == 4}" @click="handleJump(4)">联系我们</div>
  <div :class="{'active': props.active == 5}" @click="handleJump(5)">充值中心</div>
</div>
<contact-us ref="ContactUsRef" />
</template>

<style scoped lang="scss">
@import "@/style/fonts.scss";

.custom_menu {
  width: 100%;
  height: 2.8125vw;
  background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 1), rgba(0, 0, 0, 1));
  background-size: 100%;
  position: fixed;
  z-index: 9;
  top: 0;
  right: 0;
  box-sizing: border-box;
  padding: 0 5vw;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  div {
    text-align: center;
    flex: none;
    color: #fff;
    font-size: 1.4vw;
    margin-left: 4.296875vw;
    font-family: 'YouSheBiaoTiHei';
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }

    &.active {
      color: #E8FF24;
      position: relative;

      &:after {
        content: '';
        margin-left: 0;
        width: 95%;
        height: 0.15625vw;
        background-color: #E8FF24;
        position: absolute;
        bottom: -0.1953125vw;
        left: 0;
        border-radius: 0.15625vw;
      }

      &:before {
        content: '';
        width: 0.1953125vw;
        height: 0.1953125vw;
        border-radius: 50%;
        background-color: #E8FF24;
        position: absolute;
        bottom: -0.1953125vw;
        right: -0.1953125vw;
      }
    }
  }
}
</style>